import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {CloseIcon} from '../../icon/svg/close-icon';

import styles from './close-button.module.css';

type Props = {
    size?: number;
    className?: string;
    tooltip?: string;
    getRef?: (arg1?: HTMLButtonElement | null | undefined) => void;
    onClick?: (e: React.SyntheticEvent<any>) => void;
    variant?: 'dark' | 'medium' | 'light' | 'darkest';
    alignCenter?: boolean;
    onPointerDown?: (e: React.SyntheticEvent<any>) => void;
    fillColor?: string;
};

export function CloseButton(props: Props) {
    const {size = 14, variant = 'medium'} = props;

    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => {
            ReactTooltip.hide();
        };
    }, []);

    const containerStyles = classnames(styles.container, {
        [styles['container--light']]: variant === 'light',
        [styles['container--medium']]: variant === 'medium',
        [styles['container--dark']]: variant === 'dark',
        [styles['container--darkest']]: variant === 'darkest',
    });

    return (
        <button
            type='button'
            onClick={props.onClick}
            ref={props.getRef}
            data-tip={props.tooltip}
            onPointerDown={props.onPointerDown}
            className={classnames(props.className, containerStyles)}
        >
            <CloseIcon
                size={size}
                alignCenter={Boolean(props.alignCenter)}
                fill={props.fillColor}
            />
        </button>
    );
}
